export default __webpack_public_path__ + "static/media/ic-pin.4c1c8f14.svg";